import { FC } from 'react';
import { useTranslation } from 'react-i18next';
// Models
import IInsuranceCase from 'app/models/Case';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Async
// Selectors
import { selectInsuranceCase } from 'app/store/Cases/Cases.selectors';
// Mui
import { Box } from '@mui/material';
// Components
import { Button } from 'app/components/Mui';
// 
import { useUploaderSubmit } from 'app/context/UploadFiles';

type Props = {
  onClose: () => void;
};

const DialogActionButtons:FC<Props> = ({
  onClose
}) => {
  const { t } = useTranslation();
  const insuranceCase = useAppSelector(selectInsuranceCase) as IInsuranceCase;

  const { onSubmit, isLoading, isGooglePickerLoading } = useUploaderSubmit(insuranceCase.id);

  const handleSubmit = async () => {
    const result = await onSubmit();
    if (result === true) onClose();
  };

  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <Button
        name="Cancel batch dialog"
        onClick={onClose}
      >{t('buttons.close')}</Button>
      <Button
        name="Upload batch dialog"
        loading={isLoading || isGooglePickerLoading}
        onClick={handleSubmit}
        color="primary"
        variant="contained"
      >{t('buttons.upload')}</Button>
    </Box>
  )
}

export default DialogActionButtons;
